import { Voni } from '../client';

export interface DatabaseConnectionCreate {
  db_type: string;
  host: string;
  port: number;
  database_name: string;
  username: string;
  password: string;
  ssl_enabled?: boolean;
  permissions?: {
    read: boolean;
    write: boolean;
  };
}

export interface IntegrationResponse {
  success: boolean;
  integration_id: string;
}

export class IntegrationResource {
  private client: Voni;

  constructor(client: Voni) {
    this.client = client;
  }

  async createDatabase(projectId: number, config: DatabaseConnectionCreate): Promise<IntegrationResponse> {
    return this.client.request<IntegrationResponse>('POST', '/integrations/database', { project_id: projectId }, config);
  }

  async testDatabase(integrationId: number): Promise<unknown> {
    return this.client.request<unknown>('POST', `/integrations/${integrationId}/test`);
  }

  async createTokenIntegration(
    projectId: number,
    integrationType: 'telegram' | 'whatsapp',
    token: string,
    config: Record<string, unknown> = {}
  ): Promise<IntegrationResponse> {
    return this.client.request<IntegrationResponse>('POST', '/integrations/token', undefined, {
      integration_type: integrationType,
      token,
      project_id: projectId,
      config
    });
  }
}
